import logger from '@/utils/logger'

export default async function getWebPushSubscription(): Promise<PushSubscription | null> {
  try {
    const registration = await navigator.serviceWorker.ready

    // biome-ignore lint/suspicious/noTsIgnore: tsc vs tsgo difference — tsgo missing pushManager in DOM types
    // @ts-ignore: pushManager missing from tsgo's lib.dom.d.ts
    if (registration?.pushManager == null) {
      throw new Error('Notifications are not available on this browser or device')
    }

    // biome-ignore lint/suspicious/noTsIgnore: tsc vs tsgo difference — tsgo missing pushManager in DOM types
    // @ts-ignore: pushManager missing from tsgo's lib.dom.d.ts
    const subscription = await registration.pushManager.getSubscription()

    return subscription
  } catch (err) {
    logger.error('Error getting web push subscription', { err })
    return null
  }
}
